module.exports = __webpack_public_path__ + "img/slide1.55279e18.png";